import { useEffect, useRef, useState } from 'react';
import SignUpHeader from './Header';
import { ISignUp, ISignUpComponents, ISignUpInfo } from 'types/signup';
import CustomInput from 'components/common/CustomInput';
import axios from 'axios';
import { toast } from 'react-toastify';
import { layer } from 'data/layer';
import CustomSelect, { ISelectOption } from 'components/common/CustomSelect';
import AuthButton from 'components/common/AuthButton';
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import CustomDatePicker from 'components/common/CustomDatePicker';
import { formatDate } from 'components/function';
import './style.css'
import DatePicker from 'react-datepicker';

const Third = ({ signUpInfo, setSignUpInfo, setClear }: ISignUpComponents) => {
    const [selected, setSelected] = useState<ISelectOption>({} as ISelectOption)
    const signup: ISignUp[] = [
        {
            title: '사업자 등록 번호',
            key: 'bizNumberUser',
            name: 'bizNumberUser',
            type: 'text',
            placeholder: '-를 포함하지 않은 숫자만 입력해주세요',
            value: signUpInfo.bizNumberUser,
            require: true
        },
        {
            title: '사업구분',
            key: 'layer',
            name: 'layer',
            type: 'text',
            placeholder: '사업구분을 선택해주세요',
            value: signUpInfo.layer,
            require: true
        },
        {
            title: '기업명(한글)',
            key: 'companyNameKr',
            name: 'companyNameKr',
            type: 'text',
            placeholder: '사업자 등록증에 기재된 기업명을 적어주세요',
            value: signUpInfo.companyNameKr,
            require: true
        },
        {
            title: '기업명(영문)',
            key: 'companyNameEn',
            name: 'companyNameEn',
            type: 'text',
            placeholder: '예) Theinsight, LtD',
            value: signUpInfo.companyNameEn,
            require: false
        },
        {
            title: '대표자명',
            key: 'ceoName',
            name: 'ceoName',
            type: 'text',
            placeholder: '대표자 실명',
            value: signUpInfo.ceoName,
            require: true
        },
        {
            title: '개업년월일',
            key: 'establishedAt',
            name: 'establishedAt',
            type: 'date',
            placeholder: '개업년월일',
            value: signUpInfo.establishedAt ?? '',
            require: true
        },
        {
            title: '연락처',
            key: 'phoneNumber',
            name: 'phoneNumber',
            type: 'text',
            placeholder: '연락 가능 번호',
            value: signUpInfo.phoneNumber,
            require: true
        }
    ]

    const [dateReset, setDateReset] = useState<boolean>(false)
    const datePickerRef = useRef<DatePicker | null>(null);

    useEffect(() => {
        if (signUpInfo.establishedAt && datePickerRef.current) {
            const inputEl = datePickerRef.current.input as HTMLInputElement | null;
            if (inputEl) {
                setTimeout(() => {
                    inputEl.value = signUpInfo.establishedAt ?? '';
                })
            }
        }
    }, [signUpInfo]);

    useEffect(() => {
        setSignUpInfo(prev => ({
            ...prev,
            layer: selected.value
        }));
    }, [selected])

    useEffect(() => {
        signUpInfo.companyVaild && signUpInfo.phoneNumber && signUpInfo.layer ? setClear(true) : setClear(false)
        // setClear(true)
    }, [signUpInfo])

    const requiredFields = [
        { key: 'bizNumberUser' as keyof ISignUpInfo, label: '사업자 등록번호' },
        { key: 'establishedAt' as keyof ISignUpInfo, label: '개업년월일' },
        { key: 'ceoName' as keyof ISignUpInfo, label: '대표자명' },
        { key: 'companyNameKr' as keyof ISignUpInfo, label: '기업명(한글)' }
    ];

    const checkBusinessCode = async () => {
        for (const field of requiredFields) {
            const value = signUpInfo[field.key];
            if (!value || (typeof value === 'string' && value.trim() === '')) {
                toast.error(`사업자 등록번호, 기업명(한글), 대표자명, 개업년월일 입력해주세요.`);
                return;
            }
        }

        const reqData = {
            businesses: [{
                "b_no": signUpInfo.bizNumberUser.replaceAll('-', ''), // 사업자 등록번호, 법인 등록번호
                "start_dt": signUpInfo.establishedAt?.replaceAll('-', ''), // 사업 시작일
                "p_nm": signUpInfo.ceoName, // 대표자명
                "b_nm": signUpInfo.companyNameKr // 회사 이름
            }]
        }

        // "b_no": "3938701601", // 사업자 등록번호, 법인 등록번호
        // "start_dt": "20200116", // 사업 시작일
        // "p_nm": "허정", // 대표자명
        // "b_nm": "주식회사 바바그라운드", // 회사 이름
        try {
            await axios.post(`https://api.odcloud.kr/api/nts-businessman/v1/validate?serviceKey=${process.env.REACT_APP_OPEN_API_KEY}`, reqData).then(res => {
                if (res.data.data[0].valid === '01') {
                    toast.success('정상적으로 확인되었습니다.');
                    setSignUpInfo(p => ({
                        ...p,
                        companyVaild: true
                    }))
                }

                else {
                    toast.error('존재하지 않는 정보입니다.');
                    setSignUpInfo(p => ({
                        ...p,
                        companyVaild: false
                    }))
                }
            })
        } catch (err: any) {
            console.log(err)

            if (err.response.data.code === -5) {
                toast.error(`${err.response.data.msg}`);
                // setSignUpInfo({
                //     ...signUpInfo,
                //     companyVaild: true
                // })
            }
        }
    }

    return (
        <>
            <SignUpHeader title={'기업정보 입력'} idx={3} />
            <div className='mobile:flex mobile:flex-col gap-x-10 gap-y-6 mobile:gap-3 grid grid-cols-2 grid-rows-4 mobile:mb-6'>
                {
                    signup.map((item, idx) => (
                        <div className='flex flex-col items-start shrink-0' key={idx}>
                            <p className='mobile:flex mobile:flex-col font-semibold mobile:text-base text-lg'>
                                <span>
                                    {item.title}
                                    {
                                        item.require &&
                                        <span className='text-red'> *</span>
                                    }
                                </span>
                                {
                                    item.key === 'bizNumberUser' &&
                                    <span className='text-red text-sm'>사업자 등록 번호당 한아이디만 가입가능합니다.</span>
                                }
                                {
                                    item.key === 'establishedAt' &&
                                    <span className='text-red text-sm'>ex) 2025-01-01</span>
                                }
                            </p>
                            {
                                item.type === 'date' ?
                                    <CustomDatePicker
                                        ref={datePickerRef}
                                        width='full'
                                        height='15'
                                        text='lg'
                                        isMaxToday
                                        onChange={(value: Date | null | [Date | null, Date | null]) => {
                                            if (value instanceof Date && value !== null) {
                                                setSignUpInfo(p => ({
                                                    ...p,
                                                    establishedAt: formatDate(value)
                                                }));
                                            }
                                            else if (value === null) {
                                                setDateReset(true)
                                                setSignUpInfo(p => ({
                                                    ...p,
                                                    establishedAt: undefined
                                                }));
                                            }
                                        }}
                                        isReset={dateReset}
                                        setIsReset={setDateReset}
                                        disabled={signUpInfo.companyVaild}
                                    />
                                    //  <CustomInput
                                    //     className=''
                                    //     type={item.type}
                                    //     value={startDate ?? ''}
                                    //     name={item.name}
                                    //     disabled={signUpInfo.companyVaild}
                                    //     placeholder={item.placeholder}
                                    //     onChange={e => {
                                    //         setStartDate(e.target.value)
                                    //     }}
                                    // />
                                    :
                                    item.key === 'layer' ?
                                        <CustomSelect
                                            className={'w-full'}
                                            option={layer}
                                            isWhite={false}
                                            placeholder={item.placeholder}
                                            setSelected={setSelected}
                                            border={false}
                                        />
                                        :
                                        item.key === 'bizNumberUser' ?
                                            <div className='flex gap-3 w-full'>
                                                <CustomInput
                                                    type={item.type}
                                                    value={item.value ?? ""}
                                                    name={item.name}
                                                    disabled={signUpInfo.companyVaild}
                                                    placeholder={item.placeholder}
                                                    onChange={(e) => {
                                                        setSignUpInfo({
                                                            ...signUpInfo,
                                                            [item.key]: e.target.value
                                                        })
                                                    }}
                                                />
                                                <AuthButton
                                                    title='인증하기'
                                                    disabled={signUpInfo.companyVaild}
                                                    className={`shrink-0 ${(signUpInfo.bizNumberUser?.length > 0) ? 'text-primary border-primary' : 'text-[#9D9EB7] border-[#9D9EB7]'}`}
                                                    onClick={checkBusinessCode}
                                                />
                                            </div>

                                            :
                                            item.key === 'companyNameKr' ?
                                                <div
                                                    className='flex gap-3 w-full'
                                                    data-tooltip-id="my-tooltip"
                                                    data-tooltip-content="사업자 등록증에 기재된 기업명을 적어주세요"
                                                    data-tooltip-place="top"
                                                >
                                                    <Tooltip id="my-tooltip" />
                                                    <CustomInput
                                                        type={item.type}
                                                        value={item.value ?? ""}
                                                        name={item.name}
                                                        disabled={signUpInfo.companyVaild}
                                                        placeholder={item.placeholder}
                                                        onChange={(e) => {
                                                            setSignUpInfo({
                                                                ...signUpInfo,
                                                                [item.key]: e.target.value
                                                            })
                                                        }}
                                                    />
                                                </div>

                                                :
                                                <CustomInput
                                                    type={item.type}
                                                    value={item.value ?? ""}
                                                    name={item.name}
                                                    disabled={!['phoneNumber', 'companyNameEn'].includes(item.key) && signUpInfo.companyVaild}
                                                    placeholder={item.placeholder}
                                                    onChange={(e) => {
                                                        setSignUpInfo({
                                                            ...signUpInfo,
                                                            [item.key]: e.target.value
                                                        })
                                                    }}
                                                />
                            }
                        </div>
                    ))
                }
            </div>

        </>
    )
}

export default Third